import { render } from "./LedgerForm.vue?vue&type=template&id=bebcf3e0&scoped=true"
import script from "./LedgerForm.vue?vue&type=script&lang=js"
export * from "./LedgerForm.vue?vue&type=script&lang=js"

import "./LedgerForm.vue?vue&type=style&index=0&id=bebcf3e0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bebcf3e0"]])

export default __exports__